window.SLDS = window.SLDS || {};

window.SLDS["subnavigation"] = function () {
  return {
    open: false,
  };
};
